import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export function GelLabTip(props) {
  const { t } = useTranslation();

  return (
    <div className={`${props.className}_block`}>
      <div className={props.className}>
        <h3 className={`${props.className}_header labTip`}>
          {t("GelLabTipHeading.string")}
        </h3>
        <div className={`${props.className}_block_wrapper`}>
          <p className={`${props.className}_message`}>
            {t("GelLabTipText.string")}
          </p>
        </div>
      </div>
    </div>
  );
}

GelLabTip.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Balanced Status Yes/No
   */
  balanced: PropTypes.bool,
};

GelLabTip.defaultProps = {};
